import { render } from "./modal-fullscreen.vue?vue&type=template&id=9b1ba0b6&ts=true"
import script from "./modal-fullscreen.vue?vue&type=script&lang=ts"
export * from "./modal-fullscreen.vue?vue&type=script&lang=ts"

import "./modal-fullscreen.vue?vue&type=style&index=0&id=9b1ba0b6&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__